"use client";

import { DOG_SALON_SNAPS_PRODUCT } from "@/domain/product";

/**
 * First page — circular hero + soft ring motion (Stripe-ad style polish).
 */
export function DssCover({ onEnter }: { onEnter: () => void }) {
  return (
    <div className="dss-cover" role="banner">
      <button
        type="button"
        className="dss-cover-hit"
        onClick={onEnter}
        onPointerUp={(e) => {
          // iOS Safari: prefer pointerup when click is swallowed after CSS transform animations
          if (e.pointerType === "touch" || e.pointerType === "pen") {
            e.preventDefault();
            onEnter();
          }
        }}
        aria-label="はじめる"
      >
        <div className="dss-cover-mark">
          <div className="dss-cover-orbit" aria-hidden>
            <span className="dss-cover-ring r1" />
            <span className="dss-cover-ring r2" />
            <span className="dss-cover-ring r3" />
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className="dss-cover-hero"
              src={DOG_SALON_SNAPS_PRODUCT.coverHeroPath}
              alt=""
              width={1024}
              height={1024}
              decoding="async"
              fetchPriority="high"
            />
          </div>
          <div className="dss-cover-titles">
            <p className="dss-cover-short">{DOG_SALON_SNAPS_PRODUCT.shortEn}</p>
            <p className="dss-cover-full">{DOG_SALON_SNAPS_PRODUCT.productNameEn}</p>
          </div>
        </div>
        <span className="dss-cover-cta">はじめる</span>
        <span className="dss-cover-nudge">タップして開く</span>
      </button>
    </div>
  );
}
